@if (starIcon) {
  <div class="icon active" [innerHTML]="starIcon"></div>
}
